export default __webpack_public_path__ + "static/media/online.390ad38a.svg";